import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = {
  key: 0,
  d: "m240-540 240-420 240 420 Z"
}
const _hoisted_3 = {
  key: 1,
  d: "m240-440 240 420 240-420 Z"
}

import { ArrowState } from '@/types/enums/ArrowState';

export default /*#__PURE__*/_defineComponent({
  __name: 'ArrowUpDown',
  props: {
    modelValue: { default: ArrowState.BOTH }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    fill: _ctx.modelValue===_unref(ArrowState).BOTH?'currentColor':'#695cfe'
  }, [
    (_ctx.modelValue!==_unref(ArrowState).DOWN)
      ? (_openBlock(), _createElementBlock("path", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.modelValue!==_unref(ArrowState).UP)
      ? (_openBlock(), _createElementBlock("path", _hoisted_3))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})